// 封装 路由扩展 函数
'use strict'

import 'es6-promise/auto';

import routers from "../data/menus.json";

var navbars = function() { return this; };
/**
 * 根据菜单名称获取导航项
 * @param {string} name 导航名称
 */
navbars.get= function (name) {
  var pitem = undefined;
  if (routers && routers.length > 0) {
    for (var i = 0; i < routers.length; i++) {
      if (pitem === undefined && routers[i].name === name) {
        pitem = routers[i];
        break;
      }
    }
  }
  return pitem;
};

export default navbars;




// WEBPACK FOOTER //
// ./src/assets/js/navbar.js